import React, { useEffect, useState } from "react";
import { ShareNetwork } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { advisorHeaders } from "../lib/clarity";

export default function ReferralsTable() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/retention/referrals", advisorHeaders()).then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div data-testid="referrals-table" className="mt-12">
      <h2 className="font-display text-2xl mb-2 flex items-center gap-2"><ShareNetwork size={20} className="text-exodus-gold" /> Streak shares & referrals</h2>
      <p data-testid="referrals-totals" className="text-sm text-exodus-muted mb-4">{d.share_cards} share card{d.share_cards === 1 ? "" : "s"} created · {d.total_visits} link visit{d.total_visits === 1 ? "" : "s"} · {d.total_signups} sign-up{d.total_signups === 1 ? "" : "s"} from shared links</p>
      <div className="border border-exodus-border overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-exodus-elevated"><tr className="text-left text-[10px] uppercase tracking-widest text-exodus-muted">
            <th className="p-3">Referrer</th><th className="p-3">Code</th><th className="p-3">Visits</th><th className="p-3">Unique visitors</th><th className="p-3">Sign-ups</th>
          </tr></thead>
          <tbody>
            {d.items.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-exodus-muted">No shared links yet.</td></tr>}
            {d.items.map((r) => (
              <tr key={r.code} data-testid={`referral-row-${r.code}`} className="border-t border-exodus-border">
                <td className="p-3"><p>{r.name || "—"}</p><p className="text-xs text-exodus-muted">{r.email}</p></td>
                <td className="p-3 font-mono text-xs">{r.code}</td>
                <td className="p-3">{r.visits}</td><td className="p-3">{r.unique_visitors}</td>
                <td className="p-3 gold-text font-display text-xl">{r.signups}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
